import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { translate } from "react-i18next";
import { compose } from "recompose";
import axios from "axios";
import PreBook from "./PreBook.js";
import * as $ from "jquery";
import moment from "moment-timezone";
import { Redirect } from "react-router-dom";

import HelpContainer from "../HelpContainer";
import Tag from "../../components/Tag/index.jsx";
import GoBackButton from "../../components/GoBackButton/index.jsx";
let cancelToken;
let state;
let tokenSession;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

const durationTimes = {
  2: 'hrs_2',
  4: 'hrs_4',
  8: 'full_day'
}

class Room extends Component {
  getInitState = () => {
    return {
      sala: null,
      book: null,
      GoToPay: false,
      center: null,
    };
  };

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  // componentWillUnmount() {
  //     cancelToken.cancel('Component will unmount.');
  // }

  componentDidMount() {
    if (this.props.match.params.reservationsid) {
      this.getBooK({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession(),
        reservation_id: this.props.match.params.reservationsid,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.book !== this.state.book) {
      this.getRoom({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession(),
        room_id: this.state.book.sala_id,
        ingles: false,
      });
    }
  }

  componentWillUnmount() {
    // cancelToken.cancel("Component will unmount.");
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  getRoom = (params) => {
    this.props.post_store(
      "/getRoom",
      params,
      (response) => this.didGetSalas(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  };

  getBooK = (params) => {
    this.props.post_store(
      "/getBook",
      params,
      (response) => this.setState({ book: response }),
      (error) => this.handleErrorResponseBook(error),
      cancelToken
    );
  };

  getCenters = (params) => {
    this.props.post_store(
      "/getCentersByCity",
      params,
      (response) => this.setState({ center: response }),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  };

  didGetSalas = (response) => {
    if (response.centro_id) {
      this.setState({ sala: response });
      this.getCenters({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession(),
        center_id: response.centro_id,
      });
    } else {
      this.props.history.replace(`${URI_VENTA_EN_LINEA}/reservations`);
    }
  };

  handleErrorResponse = (error) => {
    alert(error);
  };

  handleErrorResponseBook = (error) => {
    // Mandar el error directamente desde la api
    alert("Se caducó la pre-reservación");
    window.location.replace(`${URI_VENTA_EN_LINEA}/reservations`);
  };

  handleConfirmarReservacion = () => {
    $("#btnSuccess").click();
  };

  handleClickPayment = () => {
    this.props.history.replace(`${URI_VENTA_EN_LINEA}/book/${this.state.book.id}`)
  }

  renderRoomResevation = (props) => {
    return (
      <PreBook
        reservation={this.state.book}
        // handleGoToPay={this.handleGoToPay}
      />
    );
  };

  renderSalasContainer = () => {
    if (!this.state.book || !this.state.sala || !this.state.center) return null

    const room = this.state.sala;
    const reservation = this.state.book;
    const duration = durationTimes[reservation.duracion];
    const center = this.state.center;
    const mapUrl = new URL(`https://www.google.com/maps/search/?api=1&query=${center.name}`);
    let endDate = null;
    let startDate = null;
    if (this.state.book) {
      endDate = moment(reservation.fecha_final, "YYYY-MM-DD HH:mm:ss");
      startDate = moment(reservation.fecha_inicial, "YYYY-MM-DD HH:mm:ss");
    }
    const { t } = this.props;
    return (
      <div className="container-room">
        <div className="container-room-header card-panel panel panel-default card card_room">
          <div className="card-panel-body">
            <h2
              className="ioscentro"
              style={{ textAlign: 'left' }}
            >{room.name.toUpperCase()}</h2>
            {/* <div className="panel-body-description"> */}
            {/* </div> */}
            <div className="row">
              <div
                className="col-md-6"
              >
                {/* <span>{room.descripcion}</span> */}
                <div className="flex-tags flex-tags__big">
                  <Tag
                    isBigTag
                    icon='people-group'
                    text={t("venta_linea.reservation_tags.capacity")}
                    value={`${room.capacidad} personas`}
                  />
                  <Tag
                    isBigTag
                    alt
                    icon='calendar'
                    text={t("venta_linea.reservation_tags.date")}
                    value={startDate.format("ll")}
                  />

                  <Tag
                    isBigTag
                    alt
                    icon='couch'
                    text={t("venta_linea.reservation_tags.room")}
                    value={room.tipo_sala}
                  />

                  <Tag
                    isBigTag
                    icon='clock'
                    text={t("venta_linea.reservation_tags.time")}
                    value={`${startDate.format("HH:mm")} - ${endDate.format("HH:mm")}`}
                  />
                  <Tag
                    isBigTag
                    icon='dollar-sign'
                    text={t("venta_linea.reservation_tags.price")}
                    value={room[duration]}
                  />
                </div>
                <div className="container-room-description">
                  <h4 className="page-header text-primary ioscentro">
                    <strong>{t("dashboard.reservations.heading_services")}</strong>
                  </h4>
                  <div className="row">
                    <div className="col-md-12">
                      <p>
                        <strong>
                          {t("dashboard.reservations.heading_included")}
                        </strong>
                      </p>
                      <section className="flex-tags">
                        {room.servicios_incluidos.map((service, index) => (
                          <Tag key={index} id={service.id} text={service.name} />
                        ))}
                      </section>
                    </div>
                    <div className="col-md-12">
                      <p>
                        <strong>
                          {t("dashboard.reservations.heading_extras")}
                        </strong>
                      </p>
                      <section className="flex-tags">
                        {room.servicios_adicionales.map((service, index) => (
                          <Tag key={index} id={service.id} text={service.name} />
                        ))}
                      </section>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6"
              >
                <div
                  className="panel-heading card-panel-heading"
                  style={{ 
                    backgroundImage: "url('" + room.imagen + "')", 
                    height: '400px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                ></div>
                <span style={{ textAlign: 'left' }}>{room.descripcion}</span>
              </div>
            </div>

            {center ? (
              <div className="row">
                <div className="col-md-6 only-desktop">
                  <div className="container-direction mapa">
                    {/* <h4 className="page-header text-primary"></h4> */}
                    <div className="iframe-wrapper">
                      <iframe
                        frameBorder="0"
                        src={
                          "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll=" +
                          center.longitude +
                          "%2C" +
                          center.latitud
                        }
                        title={t("dashboard.reservations.frame_center")}
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="container-direction text">
                    <h4 className="page-header text-primary ioscentro">
                      <strong>{t("dashboard.history.heading_address")}</strong>
                    </h4>
                    <strong>{reservation.name}</strong>
                    <a href={mapUrl.toString()} target='_blank'>
                      {center.direccion.split(",").map((row, index) => (
                        <span
                          key={index}
                          style={{ textTransform: "capitalize" }}
                        >
                          <br />
                          {row.toLowerCase()}
                        </span>
                      ))}{" "}
                      {center.ciudad.split(",").map((row, index) => (
                        <span
                          key={index}
                          style={{ textTransform: "capitalize" }}
                        >
                          <br />
                          {row.toLowerCase()}
                        </span>
                      ))}{" "}
                      {center.estado.split(",").map((row, index) => (
                        <span
                          key={index}
                          style={{ textTransform: "capitalize" }}
                        >
                          <br />
                          {row.toLowerCase()}
                        </span>
                      ))}
                    </a>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="panel-body-bottom">
              <div className="panel-body form-group">
                <button
                  className="btn btn-block btn-primary  btn-singup btn_create"
                  onClick={this.handleClickPayment}
                  type="button"
                >
                  {t("dashboard.reservations.btn_pay")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  rebderHelperContainer = () => {
    return <HelpContainer />;
  };

  handleBack = async () => {
    // eliminar la pre-reservación
    await this.props.post_store(
      "/cancelReservation",
      {
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession(),
        reservation_id: this.state.book.id,
      },
      (response) => {
        console.log(response);
      },
      (error) => {
        console.warn(error);
      },
      cancelToken
    );
  }

  render() {
    const sala = this.state.sala;

    if (this.state.book) {
      const reservationId = this.state.book.id;
      if (this.state.GoToPay) {
        return (
          <Redirect
            push
            to={{
              pathname: `${URI_VENTA_EN_LINEA}/book/${reservationId}`,
            }}
          />
        );
      }
    }
    const { t } = this.props;
    return (
      <div className="content-resvations">
        <div className="container-resvations-title">
            <GoBackButton isPayment handleBack={this.handleBack} />
            <h2 className="page-header">
              {t("dashboard.reservations.heading")}
            </h2>
        </div>
        {sala ? this.renderSalasContainer() : null}
        {this.rebderHelperContainer()}
      </div>
    );
  }
}

export default compose(translate("common"), withRouter)(Room);



// WEBPACK FOOTER //
// ./src/store/Reservation/Room.js